export default "__VITE_ASSET__DlNjdIN9__"